// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatMessageList-modulecolumn__H6ijA";
var _2 = "GretaAIChatMessageList-modulelist__CLTt9";
var _3 = "GretaAIChatMessageList-modulenoFade__C7Jnp";
var _4 = "GretaAIChatMessageList-moduleturnGap__smHaR";
var _5 = "GretaAIChatMessageList-moduleturnSpacer__H3e4L";
var _6 = "GretaAIChatMessageList-modulewrapper__G2lG9";
export { _1 as "column", _2 as "list", _3 as "noFade", _4 as "turnGap", _5 as "turnSpacer", _6 as "wrapper" }
